export default __webpack_public_path__ + "static/media/edit_outline_blue.06f56307.svg";